import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import './styles/global.css'

const app = createApp(App)

Sentry.init({
  app,
  dsn: 'https://8d3a32de59a9c07af7ae241afbdef9a0@o429735.ingest.us.sentry.io/4511013903663104',
  sendDefaultPii: true,
  enableLogs: true,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
  ],
})

app.use(router).mount('#app')
